import { render, staticRenderFns } from "./WillOtherPropertiesOccupiedFriendsDetails.vue?vue&type=template&id=aae14734"
import script from "./WillOtherPropertiesOccupiedFriendsDetails.vue?vue&type=script&lang=js"
export * from "./WillOtherPropertiesOccupiedFriendsDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports